import {
  initDatadogRum,
  registerJdid as registerJdidToRum,
} from '@iheartjane/tracking';
import { StrictMode, startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

import { beforeSend } from './services/datadogRum';
import { getClientEnv } from './services/env.client';
import { initMixpanel, registerJdid } from './services/tracking/mixpanel';

// Initialize tracking SDKs early and register the JDID, before React hydrates.
// This ensures UTM params are captured from the initial page load and that the
// very first Mixpanel/RUM events are keyed to a single, consistent JDID.
const clientEnv = getClientEnv();

if (clientEnv.mixpanelProjectToken) {
  initMixpanel(
    clientEnv.mixpanelProjectToken,
    clientEnv.nodeEnv === 'development'
  );

  if (clientEnv.jdid) {
    registerJdid(clientEnv.jdid);
  }
}

// Datadog RUM must be initialized before the JDID can be attached to its global
// context, and before hydration so the earliest errors/resources are captured.
// initDatadogRum no-ops when the Datadog env vars are absent (e.g. local dev).
initDatadogRum({
  allowedTracingUrls: [
    (url) => url.startsWith(clientEnv.publicPath ?? ''), // requests may come through bloom public url
    (url) => url.startsWith(clientEnv.menuUrl ?? ''), // requests may come through proxied url
  ],
  applicationId: clientEnv.datadog?.appId,
  beforeSend: beforeSend({ debug: clientEnv.datadog?.debug }),
  clientToken: clientEnv.datadog?.token,
  env: clientEnv.datadog?.env,
  service: 'bloom',
  version: clientEnv.buildVersion,
});

if (clientEnv.jdid) {
  registerJdidToRum(clientEnv.jdid);
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  );
});
